<template>
    <v-dialog v-bind="$attrs" persistent content-class="modal-dialog">
        <div class="modal-message">
            <div class="common-text mb-2">
                Смена темы
            </div>
            <v-form ref="form" class="auth-form" @submit.prevent>
                <div class="main-text mb-5 text-center">
                    <div class="auth-form__input mb-4">
                        <v-list class="theme-list__list">
                            <v-radio-group v-model="selectedTheme" link>
                                <v-list-item
                                    v-for="item in themeList"
                                    :key="item.value"
                                    :class="['list-theme', `list-theme-${item.value}`]"
                                >
                                    <v-list-item-content>
                                        <v-radio
                                            :label="item.name"
                                            :value="item.value"
                                        />
                                    </v-list-item-content>
                                </v-list-item>
                            </v-radio-group>
                        </v-list>
                    </div>
                </div>
                <v-flex class="d-flex w-100 justify-center mt-3">
                    <v-btn class="btn-dark main-text" @click="close">
                        Отменить
                    </v-btn>
                    <v-btn
                        type="submit"
                        class="yellow-btn small-btn main-text"
                        @click="changeTheme"
                    >
                        Сохранить
                    </v-btn>
                </v-flex>
            </v-form>
        </div>
    </v-dialog>
</template>

<script>
export default {
    name: "ModalChangeName",
    props: {
        user: {
            type: String,
            default: () => {},
        },
    },
    data() {
        return {
            selectedTheme: null,
            themeList: [
                {
                    name: "Светлая",
                    value: "light",
                },
                {
                    name: "Системная",
                    value: "system",
                },
                {
                    name: "Темная",
                    value: "dark",
                },
            ],
        };
    },
    created() {
        this.selectedTheme = localStorage.getItem('theme') || "dark";
    },
    methods: {
        close() {
            this.$emit('input', false);
        },
        changeTheme() {
            // this.$http.patch('/users/' + this.user + '/', {
            //     theme: this.selectedTheme,
            // })
            //     .then(() => {
            //         this.$emit('update');
            //         this.close();
            //     });
            document.documentElement.setAttribute('data-theme', this.selectedTheme);
            localStorage.setItem('theme', this.selectedTheme);
            localStorage.RobohomeTheme = this.selectedTheme;
            this.close();
        },
    }
}
</script>

<style lang="scss">
.theme-list__list.v-list {
    background-color: var(--dark-black-2);
    min-width: 250px;
    height: 180px;

    .list-theme.v-list-item {
        width: 250px;
        min-height: 44px !important;
        border-radius: 30px;
        box-shadow: 0px 2px 15px 0px rgba(37, 37, 37, 0.10);
        margin-bottom: 12px;

        &.list-theme-light {
            background: #F8F8F8;

            .v-input--selection-controls__input {
                .v-input--selection-controls__ripple.primary--text,
                .v-icon.primary--text {
                    color: #282424 !important;
                    caret-color: #282424 !important;
                }
            }

            .v-label {
                color: #282424 !important;
            }
        }

        &.list-theme-system {
            background: #0074B6;

            .v-input--selection-controls__input {
                .v-icon.theme--light {
                    color: rgba(255,255,255,.54) !important;
                }

                .v-input--selection-controls__ripple.primary--text,
                .v-icon.primary--text {
                    color: #FFFFFF !important;
                    caret-color: #FFFFFF !important;
                }
            }

            .v-label {
                color: #FFFFFF !important;
            }
        }

        &.list-theme-dark {
            background: #211D1D;

            .v-input--selection-controls__input {
                .v-icon.theme--light {
                    color: rgba(255,255,255,.54) !important;
                }

                .v-input--selection-controls__ripple.primary--text,
                .v-icon.primary--text {
                    color: #F8F8F8 !important;
                    caret-color: #F8F8F8 !important;
                }
            }

            .v-label {
                color: #F8F8F8 !important;
            }
        }
    }

    .v-label {
        font-weight: 400;
        font-size: 15px;
        line-height: 22px;
    }

    .v-radio .v-input--selection-controls {
        &__input {
            display: inline-flex !important;
        }

        .v-input__slot {
            margin: 0;
        }

        .v-list-item {
            min-height: 34px;
            max-height: 34px;

            &__content {
                padding: 0;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.modal-message {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.btn-dark.v-btn {
    max-width: 107px;
}

.yellow-btn.small-btn.v-btn {
    width: auto;
    min-width: 105px;
    max-height: 42px;
    min-height: 42px;
    margin-left: 8px;
}
</style>